import {default as axios} from "../../../axios";

export class Home {
    static schedule = '/scheduling';
    static testimonials = '/testimonials';
    static dynamic = '/dynamic';

    static async getSchedule() {
        const res = await axios.get(`${this.schedule}`)
        return res.data;
        return [];
    }

    static async getTestimonials() {
        const res = await axios.get(`${this.testimonials}`)
        return res.data;
    }

    static async getDynamic(page) {
        const res = await axios.get(`${this.dynamic}/${page}`)
        return res.data;
    }

}
